import { inject, Injectable } from '@angular/core';
import { take } from 'rxjs';
import { FileDownloadService } from '@app/core/services/file-download/file-download.service';
import { ILoggerMeasurement } from '@app/api/interfaces/logger-measurement.interface';

@Injectable({ providedIn: 'root' })
export class LeakDetectionSoundSignalService {
  private readonly fileDownloadService = inject(FileDownloadService);

  public download(soundSignalUrl: string | null | undefined, soundSignalId: string | null | undefined): void {
    if (!soundSignalUrl) return;

    this.fileDownloadService
      .download(soundSignalUrl, `sound-signal-#${soundSignalId}.wav`)
      .pipe(take(1))
      .subscribe({
        error: err => {
          console.error('Download failed', err);
        },
      });
  }

  public downloadByMeasurement(measurement: ILoggerMeasurement | undefined): void {
    this.download(measurement?.soundSignalUrl, measurement?.soundSignalId);
  }
}
